<template>
  <div
    class="field-wrapper-wuk sword-textarea-wuk"
    :class="{ 'sword-field-label-as-placeholder': labelAsPlaceholder,'--bg-fill': fillBg }"
  >
    <div class="label-wrapper">
      <div class="label-and-before-input-wrapper">
        <slot name="label">
          <input-label
            v-if="label"
            :label="label"
            :style-type="labelStyle"
            :info-text="labelInfo"
            :required="required && showRequiredStar"
            :disabled="disabled"
            :label-as-placeholder="labelAsPlaceholder"
            :filled="filled"
            :invalid="invalidField"
            :for="uniqueId"
          />
        </slot>

        <slot name="before-input"></slot>
      </div>
      <max-length-error :validation="validation"
                       :value="modelValue">
      </max-length-error>
    </div>

    <div
      class="sword-boxed-input-wuk sword-base-input-wuk"
      :class="[inputStateClass, errorFeedbackClass, { disabled } ]"
    >
      <textarea
        v-bind="$attrs"
        :name="name"
        :id="uniqueId"
        v-model="modelValue"
        :placeholder="computedPlaceholder"
        :required="required"
        :disabled="disabled"
        :rows="rows"
        :style="{resize}"
        @focus="setAsFocus"
        @blur="removeAsFocus"
      >
      </textarea>
    </div>
    <input-footer-wuk
      v-if="!hideErrors"
      :is-invalid="invalidField"
      :validator="validation"
      :manual-error="manualError"
      :help-text="helpText"
      :success-text="successText"
    />
  </div>
</template>

<script>

import inputHandler from '@ui-kit/mixins/inputHandler';
import inputValidationTriggers from '@ui-kit/mixins/inputValidationTriggers';

import InputLabel from '@ui-kit/components/inputs/labels/InputLabel.vue';
import MaxLengthError from '@ui-kit/components/inputs/footnotes/MaxLengthError.vue';
import InputFooterWuk from '@ui-kit/components/inputs/footnotes/InputFooter.vue';

import validationClasses from '@ui-kit/mixins/inputValidationClasses';

export default {
  name: 'SwordTextareaWuk',
  mixins: [inputHandler, inputValidationTriggers, validationClasses],
  components: {
    MaxLengthError,
    InputLabel,
    InputFooterWuk,
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array],
      required: true,
    },
    name: {
      type: String,
      default: null,
    },
    resize: {
      type: String,
      default: 'none',
      validator(value) {
        return ['none', 'both', 'horizontal', 'vertical'].indexOf(value) !== -1;
      }
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    id: {
      /**
       * Define if you want a specific id (i.e. for labels of checkbox and radio buttons)
       */
      type: String,
      required: false,
    },
    rows: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(check) {
        this.$emit('input', check);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  .sword-textarea-wuk {
    .label-wrapper {
      display: flex;
      align-items: flex-end;

      .maxlength-error-wuk {
        margin: 0;
        flex-grow: 1;
      }
    }

    textarea {
      width: 100%;
      display: block;
      padding: 0;
      margin: 0;
      border: none;
      border-radius: 0 !important;
      overflow-y: auto;
      background: $input-background-color-wuk;

      &:disabled {
        background: transparent;
      }
    }
  }
</style>
